import React from "react";

import classes from "./PaymentHistory.module.css";
import payment from "../../../../assets/svg/Seller/payment.svg";

function titleFormater(title) {
  let index = title.indexOf("of [");
  if (index !== -1) {
    title = title.slice(0, index);
  }
  return title;
}

const PaymentHistory = (props) => {
  return (
    <div className={classes.PaymentHistory}>
      {props.paymetnHistory.data.map((transaction) => {
        return (
          <div key={transaction.id} className={classes.Transaction}>
            <h1>{titleFormater(transaction.description)}</h1>
            <div className={classes.Row}>
              <p>
                ID <br />
                {transaction.id}
              </p>
              <img src={payment} alt="payment" />
            </div>
            <div className={classes.Row}>
              <p>
                Date
                <br /> {new Date(transaction.created_at).toDateString()}
              </p>
              <p>
                Time
                <br />{" "}
                {new Date(transaction.created_at)
                  .toLocaleTimeString()
                  .slice(0, 5)}
                {new Date(transaction.created_at)
                  .toLocaleTimeString()
                  .slice(-3)}
              </p>
            </div>
            <div className={`${classes.Row} ${classes.LastOne}`}>
              <p>Amount:{transaction.amount}</p>
              {/* <p>Via:{transaction.payment_vendor}</p> */}
            </div>
            {/* <p>You'v sepnt : {transaction.amount} {transaction.currency}</p> */}
          </div>
        );
      })}
    </div>
  );
};

export default PaymentHistory;
